import { Route } from 'react-router-dom';
import Home from './Home/Home';
import ProjectInfo from './ProjectInfo/ProjectInfo';
import ProjectType from './ProjectType/ProjectType';
import { DesignCondition } from './DesignCondition/DesignCondition';
import { GeogridDesign } from './GeogridDesign/GeogridDesign';
import { AdminProducts } from './Admin/AdminProducts';
import isAdminUser from '../hoc/isAdminUser';

export const endpoint = {
    home: '/',
    newProject: '/project-info',
    projectInfo: '/project-info/:id',
    projectType: '/project-type/:id',
    designCondition: '/designCondition/:id',
    results: '/results/:id',
    geogrid: '/geogrid/:id',
    geogridResults: '/geogrid-results/:id',
    adminProducts: '/admin/products',
};

export type TEndpoint = keyof typeof endpoint;

const ProtectedAdminProducts = isAdminUser(AdminProducts);

const commonRoutes = () => (
    <>
        <Route path={endpoint.home} element={<Home />} />
        {/* Per ProjectInfo, il path senza ID è per creare un nuovo progetto */}
        <Route path="/project-info" element={<ProjectInfo />} />
        <Route path={endpoint.projectInfo} element={<ProjectInfo />} />
        <Route path={endpoint.projectType} element={<ProjectType />} />
        <Route path={endpoint.designCondition} element={<DesignCondition />} />
        <Route path={endpoint.results} element={<DesignCondition />} />
        <Route path={endpoint.geogrid} element={<GeogridDesign />} />
        <Route path={endpoint.geogridResults} element={<GeogridDesign />} />
        {/* Admin routes */}
        <Route path={endpoint.adminProducts} element={<ProtectedAdminProducts />} />
    </>
);

export default commonRoutes();
